import React from "react";
import { HREF } from "../../db";
import { Link } from "react-router-dom";

function Awarded() {
  return (
    <React.Fragment>
      <div className="local fl">
        <h3>Rewards</h3>
        <div className="dqwz fr">
          Current Position：
          <Link to={HREF.INDEX}>Home</Link>&gt;
          <Link to={HREF.PUBLICATION}>Rewards</Link>&gt;
          <Link to={HREF.PUBLICATION_AWARDED}>Awarded</Link>
        </div>
      </div>
      <div className="cy-title fl">
        <ul>
          <li>
            <Link to={HREF.PUBLICATION_PAPER}>Paper</Link>
          </li>
          <li>
            <Link to={HREF.PUBLICATION_PATENT}>Patent</Link>
          </li>
          <li>
            <Link to={HREF.PUBLICATION_AWARDED} className="ej-current">
              Awarded
            </Link>
          </li>
        </ul>
      </div>
      <div className="Publications fl">
        <div className="Publications-con fl">
          <div id="vsb_content_1946_u51">
            <div id="vsb_content">
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  <strong>Prof. Xiangjie Kong's Awards:</strong>
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2021 Outstanding Member of the Chinese Computer Society
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2020 Zhejiang Province outstanding Youth Fund winner
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2020 IEEE Vehicle Technology Society (VTS) Best Land Transport Award (Best Land Transport)
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2020 Second Prize of Excellent Papers at the Annual Conference of Liaoning Computer Society
                </span>
              </p>
              
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2020 Xiangjie Kong was awarded the Excellent Graduation
                  Thesis Supervisor of Dalian University of Technology
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2019 Xiangjie Kong won the Outstanding Postgraduate Teaching
                  Achievement Award of Dalian University of Technology
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2019 IEEE Access International Journal Outstanding Editorial Board in 2018
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2019 Second prize of Liaoning Province Natural Science Academic Achievement Award
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2018 Outstanding Reviewer of JOURNAL OF ISA TRANSACTIONS
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2018 Outstanding Reviewer of JOURNAL OF THE FRANKLIN
                  INSTITUTE
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2018 Outstanding Associate Editor of 2018 for IEEE Access
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2018 Third Prize of Liaoning Province Natural Science
                  Academic Achievement Award
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2018 Outstanding Reviewer of Journal of The Franklin Institute International Journal in 2017
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2018 Outstanding Reviewer of ISA Transactions International Journal in 2017
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2017  IEEE Senior Member
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2017 First Prize of Liaoning Province Natural Science
                  Academic Achievement Award
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2017 Excellent Teaching Quality Award of Dalian University
                  of Technology
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2017 First Prize of Liaoning Province Natural Science
                  Academic Achievement Award
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2017 Outstanding Graduation Thesis Supervisor for
                  Undergraduates of Dalian University of Technology
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2016 Excellent Teaching Quality Award of Dalian University
                  of Technology
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2016 First Prize of Liaoning Province Natural Science
                  Academic Achievement Award
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2016 Second Prize of Excellent Papers in the Ninth National
                  University Computer Network Teaching and Network Engineering
                  Professional Construction Seminar
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2015 The second prize of the lecture competition for young
                  teachers of the School of Software, Dalian University of
                  Technology
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2015 Feng Xia, Xiangjie Kong, Zhuo Yang, Zhikui Chen, Lin
                  Yao Second Prize of Liaoning Education and Teaching
                  Informatization Competition Provincial Level
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2014 Feng Xia, Jie Li, Ruonan Hao, Xiangjie Kong Third Prize
                  of Natural Science Academic Achievement Award of Liaoning
                  Province Provincial Level
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2014 Outstanding Party Member, School of Software of Dalian
                  University of Technology
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2014 Excellent Lecturer of H3C Network Academy School Level
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2013 Excellent Teaching Quality Award of Dalian University
                  of Technology
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2013 Outstanding Graduation Thesis Supervisor for
                  Undergraduates of Dalian University of Technology
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2012 Excellent Teaching Quality Award of Dalian University
                  of Technology
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2012 Excellent Master Thesis Supervisor of Dalian University
                  of Technology
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2011 Excellent Head Teacher of Dalian University of
                  Technology
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2011 Outstanding Graduation Thesis Supervisor for
                  Undergraduates of Dalian University of Technology
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2010 Dalian University of Technology Postgraduate Excellent
                  Courses Lecturer School Level
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2010 Outstanding Graduation Thesis Supervisor for
                  Undergraduates of Dalian University of Technology
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export { Awarded };
